import React from "react";

const CATALOG_FIELDS = [
    { key: "title", label: "Title" },
    { key: "price", label: "Sell Price" },
    { key: "image_url", label: "Image URL" },
    { key: "supplier", label: "Supplier" },
    { key: "expiration_date", label: "Expiration Date" },
    { key: "purchase_date", label: "Purchase Date" },
    { key: "notes", label: "Notes" },
    { key: "brand", label: "Brand" },
];

const ColumnMappingRow = ({ header, sample, config, costDefinitions, flagDefinitions, fieldDefinitions, onChange }) => {
    const type = config?.type || "ignore";
    const update = (patch) => onChange({ ...config, ...patch });

    return (
        <div className="border border-gray-100 rounded-xl p-3">
            <div className="flex items-center gap-3 mb-2">
                <div className="flex-1">
                    <p className="text-sm font-semibold text-gray-800">{header}</p>
                    {sample !== undefined && <p className="text-xs text-gray-400 truncate">e.g. "{String(sample)}"</p>}
                </div>
                <select value={type} onChange={(e) => onChange({ type: e.target.value })}
                    className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs font-semibold">
                    <option value="ignore">Ignore</option>
                    <option value="field">Catalog Field</option>
                    <option value="cost">Cost</option>
                    <option value="flag">Flag</option>
                    <option value="custom_field">Custom Field</option>
                    <option value="fee">Walmart Fee</option>
                </select>
            </div>

            {type === "field" && (
                <select value={config?.target_id || ""} onChange={(e) => update({ target_id: e.target.value })}
                    className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs">
                    <option value="">Select field...</option>
                    {CATALOG_FIELDS.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
                </select>
            )}

            {type === "cost" && (
                <div className="flex gap-2 items-center flex-wrap">
                    <select
                        value={config?.create_new ? "__new__" : config?.target_id || ""}
                        onChange={(e) => {
                            if (e.target.value === "__new__") update({ create_new: true, target_id: null, name: header });
                            else update({ create_new: false, target_id: e.target.value });
                        }}
                        className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs flex-1"
                    >
                        <option value="">Select cost type...</option>
                        {costDefinitions.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                        <option value="__new__">+ Create new cost type</option>
                    </select>
                    {config?.create_new && (
                        <input value={config?.name || ""} onChange={(e) => update({ name: e.target.value })}
                            placeholder="New cost type name" className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs flex-1" />
                    )}
                </div>
            )}

            {type === "custom_field" && (
                <div className="flex gap-2 items-center flex-wrap">
                    <select
                        value={config?.create_new ? "__new__" : config?.target_id || ""}
                        onChange={(e) => {
                            if (e.target.value === "__new__") update({ create_new: true, target_id: null, name: header });
                            else update({ create_new: false, target_id: e.target.value });
                        }}
                        className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs flex-1"
                    >
                        <option value="">Select custom field...</option>
                        {(fieldDefinitions || []).map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                        <option value="__new__">+ Create new custom field</option>
                    </select>
                    {config?.create_new && (
                        <input value={config?.name || ""} onChange={(e) => update({ name: e.target.value })}
                            placeholder="New custom field name" className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs flex-1" />
                    )}
                </div>
            )}

            {type === "fee" && (
                <select value={config?.fee_key || ""} onChange={(e) => update({ fee_key: e.target.value })}
                    className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-xs">
                    <option value="">Select fee type...</option>
                    <option value="referral_fee">Referral Fee</option>
                    <option value="wfs_fee">WFS Fee</option>
                    <option value="fulfillment_cost">Fulfillment Cost (SF shipping)</option>
                    <option value="inbound_shipping">Inbound Shipping (WFS)</option>
                    <option value="sales_tax">Sales Tax (on cost)</option>
                    <option value="total_fees">Total Fees (override entire breakdown)</option>
                </select>
            )}
            {type === "flag" && (
                <div className="space-y-2">
                    <div className="flex gap-2">
                        <button onClick={() => update({ mode: "fixed" })}
                            className={`px-3 py-1 rounded-lg text-xs font-bold border-2 ${(config?.mode || "fixed") === "fixed" ? "border-teal-500 bg-teal-50 text-teal-700" : "border-gray-200 text-gray-500"}`}>
                            Fixed flag (yes/no column)
                        </button>
                        <button onClick={() => update({ mode: "value_as_flag" })}
                            className={`px-3 py-1 rounded-lg text-xs font-bold border-2 ${config?.mode === "value_as_flag" ? "border-teal-500 bg-teal-50 text-teal-700" : "border-gray-200 text-gray-500"}`}>
                            Each value is its own flag
                        </button>
                    </div>

                    {(config?.mode || "fixed") === "fixed" && (
                        <div className="flex gap-2 items-center flex-wrap">
                            <select
                                value={config?.create_new ? "__new__" : config?.target_id || ""}
                                onChange={(e) => {
                                    if (e.target.value === "__new__") update({ create_new: true, target_id: null, name: header });
                                    else update({ create_new: false, target_id: e.target.value });
                                }}
                                className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs flex-1"
                            >
                                <option value="">Select flag...</option>
                                {flagDefinitions.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                                <option value="__new__">+ Create new flag</option>
                            </select>
                            {config?.create_new && (
                                <input value={config?.name || ""} onChange={(e) => update({ name: e.target.value })}
                                    placeholder="New flag name" className="border border-gray-200 rounded-lg px-3 py-1.5 text-xs flex-1" />
                            )}
                        </div>
                    )}
                    {config?.mode === "value_as_flag" && (
                        <p className="text-xs text-gray-400">
                            Each unique value in this column becomes its own flag (e.g. "New", "Damaged", "Refurbished").
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ColumnMappingRow;